import React, { useEffect, useState } from 'react'
import { Row, Button, Col, Form, Container, Modal } from "react-bootstrap";
//import DEFAULT_URL from '../../../../api/url';
import { SuccessModal } from '../../../Utils/SuccessModal/SuccessModal';
import { ErrorModal } from '../../../Utils/ErrorModal/ErrorModal';
const ModalNuevoLead = (props) => {
    const [contador, setContador] = useState(0);
    const [origenes, setOrigenes] = useState([]);
    const [uniqueID, setUniqueID] = useState('');
    const [nombre, setNombre] = useState('');
    const [puesto, setPuesto] = useState('');
    const [institucion, setInstitucion] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [origen, setOrigen] = useState('');
    const [modalSucc, setModalSucc] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [consideracion, setConsideracion] = useState('');
    useEffect(() => {
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/auth/userinfo', {cache: "no-cache",  credentials: 'include' })
            .then((res) => {
                return res.json();
            })
            .then(data => {
                setUniqueID(data.UniqueID);
                fetch(process.env.REACT_APP_DEFAULT_URL + '/api/read/leads/origen', { cache: "no-cache", credentials: 'include' })
                    .then((res) => {
                        return res.json();
                    })
                    .then(data => {
                        setOrigenes(data.rows);
                    });
            });
    }, [contador]);
    const ocultar = () => {
        setModalError(false);
        setModalSucc(false);
        setContador(contador + 1);
        props.onHide();
    }
    const onChange = (evt) => {
        switch (evt.target.name) {
            case "Nombre":
                setNombre(evt.target.value);
                break;
            case "Puesto":
                setPuesto(evt.target.value);
                break;
            case "Institucion":
                setInstitucion(evt.target.value);
                break;
            case "Correo":
                setCorreo(evt.target.value);
                break;
            case "Telefono":
                setTelefono(evt.target.value);
                break;
            case "Origen":
                setOrigen(evt.target.value);
                break;
        }
    }
    const submit = (evt) => {
        evt.preventDefault();
        const info = { Nombre: nombre, Puesto: puesto, Institucion: institucion, Correo: correo, Telefono: telefono, Origen: origen, Asesor: uniqueID };
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        };
        fetch(process.env.REACT_APP_DEFAULT_URL + '/api/create/leads', requestOptions)
            .then((res) => {
                return res.json();
            })
            .then(data => {
                if (data.codigo == 200) {
                    setModalSucc(true);
                    setMensaje('Lead ingresado al sistema exitosamente');
                } else {
                    setModalError(true);
                    setMensaje('ERROR');
                }
            });
    }
    const entering = () => {
        setNombre('');
        setPuesto('');
        setInstitucion('');
        setCorreo('');
        setTelefono('');
        setOrigen('-1');
        setModalSucc('');
        setModalError('');
        setMensaje('');
        setConsideracion('');
        setContador(contador + 1);
    }
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
            onEnter={entering}
        >
            <Modal.Header closeButton style={{ backgroundColor: "#b5bad0" }}>
                <Modal.Title id="contained-modal-title-vcenter" className="font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-plus-circle-dotted" viewBox="0 0 16 16">
                        <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                    </svg>
                    &nbsp;&nbsp;&nbsp;Registrar lead
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#b5bad0" }} className="cuerpo-modal-nuevo-cliente">
                <Container>
                    <Form onSubmit={submit}>
                        <Row>
                            <Col xs={12} md={12}>
                                <Form.Group className="mb-3" controlId="Nombre">
                                    <Form.Label>Nombre de la persona que solicita el evento</Form.Label>
                                    <Form.Control type="text" placeholder="Ingrese el nombre del lead" name="Nombre" onChange={onChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Form.Group className="mb-3" controlId="Direccion">
                                <Form.Label>Puesto de trabajo</Form.Label>
                                <Form.Control type="text" rows={3} style={{ resize: 'none' }} placeholder="Ingrese el puesto de trabajo del lead" name="Puesto" onChange={onChange} />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <Form.Group className="mb-3" controlId="Institucion">
                                    <Form.Label>Nombre de la institución</Form.Label>
                                    <Form.Control type="text" placeholder="Ingrese la institución lead" name="Institucion" onChange={onChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <Form.Group className="mb-3" controlId="Correo">
                                    <Form.Label>Correo electrónico</Form.Label>
                                    <Form.Control type="text" placeholder="Ingrese el correo del lead" name="Correo" onChange={onChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <Form.Group className="mb-3" controlId="Telefono">
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control type="text" placeholder="Ingrese el teléfono del lead" name="Telefono" onChange={onChange} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12}>
                                <Form.Group className="mb-3" controlId="origen">
                                    <Form.Label>Origen</Form.Label>
                                    <Form.Control as="select" required aria-label="origen" name="Origen" onChange={onChange}>
                                        <option value="" key="-1">Seleccione el origen del lead</option>
                                        {origenes.map((origen) =>
                                            <option value={origen.UniqueID} key={origen.UniqueID}>{origen.nombre}</option>
                                        )}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Button variant="secondary" className="font-bold" type="submit">Guardar</Button>
                        </Row>
                    </Form>
                </Container>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#b5bad0" }}>
                <Button variant="secondary" className="font-bold" onClick={props.onHide}>Cancelar</Button>
            </Modal.Footer>
            <ErrorModal
                color={"#b5bad0"}
                show={modalError}
                onHide={ocultar}
                mensaje={mensaje}
                consideracion={consideracion}
            />
            <SuccessModal
                color={"#b5bad0"}
                show={modalSucc}
                onHide={ocultar}
                mensaje={mensaje}
                consideracion={consideracion}
                enlace={''}
                llevaenlace={false}
            />
        </Modal>
    )
}

export default ModalNuevoLead